const dip_countries = [
  { code: 'US', name: 'United States' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'SG', name: 'Singapore' },
  { code: 'HK', name: 'Hongkong' },
  { code: 'MT', name: 'Malta' },
  { code: 'DE', name: 'Germany' },
  { code: 'AU', name: 'Australia' },
  { code: 'CA', name: 'Canada' },
];

// Constants Varibles
const DEDICATED_SERVER = 'dedicated_server';
const DEDICATED_IP= 'dedicated_ip';
const PORT_FORWARDING = 'port_forwarding';
const PORT_FORWARDING_DEDICATED_IP= 'port_forwarding_with_dedicated_ip';
const DDOS_PROTECTION = 'ddos_protection';
const MULTI_LOGIN = 'multi_login_limit';
const TEAM_SERVER = 'team_server';
const RESIDENTIAL_NETWORK = 'residential_network';
const RESIDENTIAL_NETWORK_BANDWIDTH = 'residential_network_bandwidth';
const OLD_MULTI_LOGIN = 'multi_login';
const WIRE_GUARD = 'wireguard';
const PUREVPN_SEAT = 'seat';

const PURE_KEEP = 'purekeep';
const PURE_CRYPT = 'purecrypt';
const PURE_SCAN = 'purescan';
const PURE_VPN ='purevpn';

const PURE_STORAGE = 'purestorage';
const PURE_CIRCLE = 'purecircle';

const PURE_SCAN_DISCOUNTED = 'purescan_discounted';
const PURE_KEEP_DISCOUNTED = 'purekeep_discounted';
const PURE_CRYPT_DISCOUNTED = 'purecrypt_discounted';

export default {
  DEDICATED_SERVER,
  DEDICATED_IP,
  PORT_FORWARDING,
  PORT_FORWARDING_DEDICATED_IP,
  DDOS_PROTECTION,
  MULTI_LOGIN,
  OLD_MULTI_LOGIN,
  PUREVPN_SEAT,
  TEAM_SERVER,
  RESIDENTIAL_NETWORK,
  RESIDENTIAL_NETWORK_BANDWIDTH,
  WIRE_GUARD,
  PURE_VPN,
  PURE_CRYPT,
  PURE_SCAN,
  PURE_KEEP,
  PURE_STORAGE,
  PURE_CIRCLE,
  PURE_SCAN_DISCOUNTED,
  PURE_KEEP_DISCOUNTED,
  PURE_CRYPT_DISCOUNTED,
  addonWithCountries: [
    DDOS_PROTECTION,
    DEDICATED_IP,
    DEDICATED_SERVER,
    PORT_FORWARDING_DEDICATED_IP
  ],
  addonWithCities: [
    DEDICATED_SERVER
  ],
  addonsCountryList: {
    ddos_protection: [
      { code: 'US', name: 'United States' },
      { code: 'GB', name: 'United Kingdom' },
      { code: 'NZ', name: 'New Zealand' },
      { code: 'NL', name: 'Netherlands' },
      { code: 'AU', name: 'Australia' },
      { code: 'CA', name: 'Canada' },
      { code: 'DE', name: 'Germany' },
      { code: 'FR', name: 'France' },
    ],
    dedicated_ip: dip_countries,
    port_forwarding_with_dedicated_ip: dip_countries,
  },
  vpnAddonsList: [
    DEDICATED_IP,
    PORT_FORWARDING,
    DEDICATED_SERVER,
    MULTI_LOGIN
  ],
  powerPackAddon: PORT_FORWARDING_DEDICATED_IP,
  specialAddonList: [
    PURE_KEEP,
    PURE_CRYPT,
    PURE_SCAN,
    PURE_STORAGE,
    PURE_CIRCLE
  ],
  excludeAddonsOnTrial: [
    RESIDENTIAL_NETWORK,
    RESIDENTIAL_NETWORK_BANDWIDTH,
    DEDICATED_SERVER
  ],
  specialAddonListMax: [
    PURE_KEEP,
    PURE_CRYPT,
    PURE_SCAN
  ],
  specialAddonListPlus: [
    PURE_KEEP,
    PURE_CRYPT
  ],
  specialDiscountedAddonList: [
    PURE_SCAN_DISCOUNTED,
    PURE_KEEP_DISCOUNTED,
    PURE_CRYPT_DISCOUNTED
  ],
  addonsToBeDisabled: {
    port_forwarding_with_dedicated_ip: [
      DEDICATED_IP,
      PORT_FORWARDING,
      DDOS_PROTECTION
    ],
    ddos_protection: [
      DEDICATED_IP,
      DEDICATED_SERVER,
      PORT_FORWARDING_DEDICATED_IP
    ],
    port_forwarding: [
      PORT_FORWARDING_DEDICATED_IP
    ],
    dedicated_ip: [
      PORT_FORWARDING_DEDICATED_IP,
      DDOS_PROTECTION
    ],
    dedicated_server: [
      DDOS_PROTECTION
    ],
  },
  teamsAddonList: [
    DEDICATED_IP,
    TEAM_SERVER,
    RESIDENTIAL_NETWORK_BANDWIDTH,
    PORT_FORWARDING
  ],
  quantityKeysByAddon: {
    [MULTI_LOGIN]: "multiLoginQuantity",
    [RESIDENTIAL_NETWORK_BANDWIDTH]: "residentialNetworknBandwidthQuantity"
  },
  quantityKeysByAddonForTeamPlan: {
    [PURE_VPN]: "teamQuantity",
    [DEDICATED_IP]: "dedicatedIpsQuantity",
    [RESIDENTIAL_NETWORK_BANDWIDTH]: "residentialNetworknBandwidthQuantity"
  }
};
